import React, { useEffect, useState } from 'react';
import ModalFormAccesories from '../../components/forms/catalog/modal.form.accesories';
import ListTables from '../../components/shared/tables';
import Base from '../base';
import { Alert } from '@themesberg/react-bootstrap';
import { get } from '../../services/back.service';

function ListAccesories() {
  const [msgGet, setMsgGet] = useState('');
  const [accesories, setAccesories] = useState([]);
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    type: '',
  });


  useEffect(() => {
    getAccesories();
  }, []);

  const createvehicleType = (variant, msg) => {
    setAlert({ show: true, message: msg, type: variant });
    getAccesories();
  };

  // const editvehicleType = () => {
  //   setAlert({ show: true, message: 'Tipo Editado Correctamente' });
  //   getAccesories();
  // };

  const editButton = (row) => {
    return (
      <ModalFormAccesories
        title="Modificar Accesorio"
        button_text="Editar"
        button_variant="outline-primary"
        vehicleTypeSelect={row.id}
        callback={createvehicleType}
      ></ModalFormAccesories>
    );
  };

  const getAccesories = async () => {
    const responseaccesories = await get('/catalog/accesories/', {})
    if (responseaccesories.success) {
      setAccesories(responseaccesories.data);
    } else {
      setMsgGet(responseaccesories.message)
    }
  }

  return (
    <Base>
      {/* <TempAlert show={alert.show} variant="success" message={alert.message} hide={setAlert} ></TempAlert> */}
      {alert.show && <Alert variant={alert.type} onClose={() => setAlert({ show: false })} dismissible>{alert.message}</Alert>}
      <ModalFormAccesories
        title="Crear Accesorio"
        button_text="Crear Accesorio"
        button_variant="primary"
        callback={createvehicleType}
      ></ModalFormAccesories>
      <ListTables
        data={accesories}
        editar={editButton}
        messageWd={msgGet}
      />
    </Base>
  );
}

export default ListAccesories;
